import moment from 'moment'
import { combineEpics } from 'redux-observable'
import { createListable } from 'listable'
import options from './config'
import { createEffects } from './effects'
import * as customActions from './actions'
import { moduleName } from './actions/types'
import customReducer from './reducer'


const listableModule = createListable({
  name: moduleName,
  config: options,
  customActions,
  customReducer,
})

export const config = listableModule.options
export const actions = listableModule.actions

export const effects = combineEpics(
  createEffects(listableModule.actions),
  listableModule.effects,
)

export const name = listableModule.name
export const reducer = listableModule.reducer
export const types = listableModule.types

export const constants = {
  ...listableModule.constants,
  PATH_ALL: `/relief-vehicles`,
  PATH_ADD: `/relief-vehicles/new`,
  PATH_SINGLE: `/relief-vehicles/booking`,
  ROUTE_ALL: `/relief-vehicles`,
  ROUTE_ADD: `/relief-vehicles/new`,
  ROUTE_SINGLE: `/relief-vehicles/booking/:id`,
}

export const createDefaultModel = () => ({
  createdAt: moment().toISOString(),
  status: 'sent to tfs',
  collectionDate: null,//moment().add(1, 'days'),
  bookedReturnDate: null //,moment().add(7, 'days'),
})
